import { TimeOfDayModule } from '../../../../components/displays/alerts/components/addAlertComponent/addAlertForm/formComponents/setupFilters/setupFiltersModules/timeOfDay/TimeOfDayModule';
import { TimeOfDayBox } from '../../../../components/displays/charts/d3/candlestickchart/newCandleChart/softOrders/softOrderChartComponents/setupFilters/TimeOfDayBox';
import { TimeOfDayTacticPanel } from '../../../../components/displays/tradeplans/activeTradePlanModule/components/detailsSection/individualTacticPanels/setupFilters/TimeOfDayTacticPanel';
import { TimeOfDayModuleWrapper } from '../../../../components/displays/tradeplans/softOrderModules/SetupFilterModules/TimeOfDayModule/wrapper/TimeOfDayWrapper';
import TimeOfDayDocumentation from '../../../../components/forms/tradeplans/documentation/TimeOfDayDocumentation';
import { timeOfDayFilterParser } from '../../../../stores/websocketStore/utils/mungingUtils/alertSoftOrderProcessing/individualFilterStatusParsers/timeOfDay/timeOfDayFilterParser';
import { TimeOfDayData } from './timeOfDayData';
import { validateTimeOfDay } from './validateTimeOfDay';

export const TimeOfDay = {
  //data class
  dataStore: TimeOfDayData,

  //string constants
  name: 'TIME_OF_DAY',
  tacticLabel: 'Time of Day',
  addTacticLabel: 'Add Time of Day',
  category: 'Setup Filter',


  // components
  tradePlanFormModule: null,
  tacticPanel: TimeOfDayTacticPanel,
  addTacticPanel: null,
  wrapper: TimeOfDayModuleWrapper,
  chartSoftOrderComponent: TimeOfDayBox,
  documentation: TimeOfDayDocumentation,
  alertDetailsComponent: TimeOfDayModule,

  //functions
  setupDetailParser: null, //todo
  filterStatusParser: timeOfDayFilterParser,
  validationFunction: validateTimeOfDay,
};
